<template>
    <div>
        <div class="permissions-title">{{ $t('permission_configuration_management.permission.permissionOverview') }}</div>
        <div class="permissions-top">
            <permission-search></permission-search>
        </div>
        <table-permissions></table-permissions>
    </div>
</template>

<script>

    import PermissionSearch from "./PermissionSearch";
    import TablePermissions from "./TablePermissions";

    export default {
        name: 'permissions',
        components: {
            PermissionSearch,
            TablePermissions
        }
    }
</script>

<style scoped>
    .permissions-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .permissions-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/permission/Permissions.vue